import { render, staticRenderFns } from "./FieldReference.vue?vue&type=template&id=41afb3f4&scoped=true"
import script from "./FieldReference.vue?vue&type=script&lang=js"
export * from "./FieldReference.vue?vue&type=script&lang=js"
import style0 from "./FieldReference.vue?vue&type=style&index=0&id=41afb3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41afb3f4",
  null
  
)

export default component.exports